import React from 'react'
import Hadear from './layout/Hadear'
import Footer from './layout/Footer'
import { Outlet } from 'react-router-dom';
import WhatsappIcon from '../pages/WhatsappIcon';

const MainLayOut = () => {
  return (
    <>
      <Hadear />
      <Outlet />
      <WhatsappIcon />
      <Footer />
    </>
  );
}

export default MainLayOut